export default {
	websiteErr: 'The website displays abnormally, please check and try again!',
	searchBtn: 'Search',
	searchPlaceholder: 'Please enter keyword of the product',
	platform: 'Proxy Platform',
	selectPlatform: 'Please select a purchasing platform',
	buyNow: 'Buy Now',
	bestSeller: 'Best Sellers',
	newArrivals: 'New Arrivals',
	all: 'All',
	viewAll: 'Show All',
	noData: 'No Data',
	noProduct: 'No Products',
	dataLoading: 'Data Loading...',
	loadingFinish: 'All Data Loaded',
	selectCategory: 'Select Category',
	selectBrand: 'Select Brand',
	selectPlatform2: 'Choose a purchasing platform',
	close: 'Close'
}